export const getStaticImageMap = (latlng: string) => {
  return `https://maps.googleapis.com/maps/api/staticmap?center=${latlng}&zoom=17&markers=color:pink%7Clabel:o%7Csize=100*100%7C${latlng}&size=1000x1000&key=${
    process.env.REACT_APP_API_GOOGLE_KEY || ""
  }`;
};
